import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AdAccountContext = createContext(null);

export function AdAccountProvider({ children }) {
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState(() => localStorage.getItem("ad_account_id"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    if (!localStorage.getItem("token")) { setLoading(false); return; }
    api.get("/ad-accounts").then((r) => {
      if (!mounted) return;
      setAccounts(r.data || []);
      if (!selected && r.data?.length) {
        const first = r.data[0].id;
        setSelected(first);
        localStorage.setItem("ad_account_id", first);
      }
    }).catch(()=>{}).finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []); // eslint-disable-line

  const select = (id) => {
    setSelected(id);
    localStorage.setItem("ad_account_id", id);
  };

  return (
    <AdAccountContext.Provider value={{ accounts, selected, select, loading }}>
      {children}
    </AdAccountContext.Provider>
  );
}

export const useAdAccount = () => useContext(AdAccountContext);
